export const locale = {
    lang: 'fr',
    data: {
        RESULT: 'Résultats',
        CANCEL: 'Fermer',
    }
};
